module.exports = __webpack_public_path__ + "static/4-c0b690424f39d2186a8c3b5bff4c4ccd.png";